import { render, staticRenderFns } from "./classroomInter.vue?vue&type=template&id=1887f07d&scoped=true"
import script from "./classroomInter.vue?vue&type=script&lang=js"
export * from "./classroomInter.vue?vue&type=script&lang=js"
import style0 from "./classroomInter.vue?vue&type=style&index=0&id=1887f07d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1887f07d",
  null
  
)

export default component.exports